/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tyc_Obligations_S42_IntroInputs */

const es_tyc_obligations_s42_intro = /** @type {(inputs: Tyc_Obligations_S42_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No debe:`)
};

const en_tyc_obligations_s42_intro = /** @type {(inputs: Tyc_Obligations_S42_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You must not:`)
};

/**
* | output |
* | --- |
* | "You must not:" |
*
* @param {Tyc_Obligations_S42_IntroInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tyc_obligations_s42_intro = /** @type {((inputs?: Tyc_Obligations_S42_IntroInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tyc_Obligations_S42_IntroInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tyc_obligations_s42_intro(inputs)
	return en_tyc_obligations_s42_intro(inputs)
});
export { tyc_obligations_s42_intro as "tyc.obligations.s42_intro" }